import React, { memo } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import Layout from './components/Layout/Layout';
import HomePage from './components/HomePage/HomePage';
import References from './components/References/References';
import RequestAnEstimate from './components/RequestAnEstimate/RequestAnEstimate';
import PhotoGallery from './components/PhotoGallery/PhotoGallery';
import Roofing from './components/Roofing/Roofing';
import Carpentry from './components/Carpentry/Carpentry';
import Siding from './components/Siding/Siding';

import './App.css';

// Memoize HomePage to prevent unnecessary rerenders
const MemoizedHomePage = memo(HomePage);

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      children: [
        {
          index: true,
          element: <MemoizedHomePage />, // Use the memoized version
        },
        {
          path: "references",
          element: <References />,
        },
        {
          path: "requestanestimate",
          element: <RequestAnEstimate />,
        },
        {
          path: "photogallery",
          element: <PhotoGallery />,
        },
        {
          path: "roofing",
          element: <Roofing />,
        },
        {
          path: "carpentry",
          element: <Carpentry />,
        },
        {
          path: "siding",
          element: <Siding />,
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
}

export default App;